import axios from "../helper/axios";
import { create } from "zustand";

const useNuJobsStore = create((set) => ({
  allGlobalEvals: [],
  myApplication: null,
  selectedEval: null,
  myEvals: null,
  myResume: null,
  myQuestions: null,
  myJdArray: null,
  myEvalResults: null,
  myFavouriteEvalIDs: null,
  myFavouriteEvals: null,
  nujobsEvalPagination: null,
  totalEvals: 0,

  sendEvalAnswers: async (body) => {
    try {
      var qsetUserData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
      const response = await axios.post(
        `/nujobsEvalQSetAnswers/${qsetUserData.nujuid}/${body.ev_id}`,
        body.jasonValues,
      );
      console.log(response.data);
      //set({ selectedProfileResume: response?.data });
    } catch (err) {
      console.error(err);
    }
  },

  updateEvalStatus: async (body) => {
    try {
      var qsetUserData = JSON.parse(localStorage.getItem("qsetUserDetails"));
      const response = await axios.post(
        `/qsetEvalSetUpdateStatus/${qsetUserData.sessionid}/${qsetUserData.qhoid}/${qsetUserData.qhrid}/${qsetUserData.qhcompanyjid}/${body.ev_id}`,
        body.jasonValues,
      );
      //console.log(response.data)
      //set({ selectedProfileResume: response?.data });
    } catch (err) {
      console.error(err);
    }
  },

  getMyEval: async (sessionid) => {
    try {
      var qsetUserData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
      const response = await axios.get(
        `/qsetGetMyEvals/${sessionid}/${qsetUserData.qhoid}/${qsetUserData.qhcompanyjid}/${qsetUserData.qhrid}`,
      );
      console.log("My Evals", response.data);
      console.log(response.data.data);
      set({
        myEvals: response?.data.data,
        myQuestions: response?.data.qarray,
        myJdArray: response?.data.jdarray,
      });
    } catch (err) {
      console.log("My Evals Data Error", err);
      console.error(err);
    }
  },

  getAllGlobalEvals: async (body) => {
    try {
      console.log("getAllGlobalEvals");
      var userData = JSON.parse(localStorage.getItem("userDetails"));
      const response = await axios.get(`/nujobs/evaluations/list`, {
        params: {
          state: body?.state || "",
          duration: body?.duration || "",
          skill: body?.skill || "",
        },
      });
      console.log("All Evals Global", response);
      //console.log(response.data.data);
      //console.log(response.data.eStatsArr);

      set({
        allGlobalEvals: response.data.data,
        nujobsEvalPagination: response.data.pagination,
        totalEvals: response.data.total,
        //  allJDEvalsStats: response?.data.stats,
      });
    } catch (err) {
      console.log("Evals Data Error", err);
      console.log(err.response);
      console.error(err);
    }
  },

  getQuestionsForEvaluation: async (evaluation_id) => {
    var userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
    const response = await axios.get(`/nujobs/evaluations/${evaluation_id}`);
    set({
      myQuestions: response?.data.questions,
      selectedEval: response?.data.data,
    });
  },

  getMyEvalResults: async (evaluation_id) => {
    var userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
    const response = await axios.get(
      `/nujobsGetUserEvalResult/${userData.nujuid}/${evaluation_id}`,
    );
    set({ myEvalResults: response?.data?.data.result });
    console.log(response?.data?.data.result, "My Eval Results");
  },

  getMyEvals: async () => {
    var userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
    const response = await axios.get(
      `/nujobsGetUserEvalResult/${userData.nujuid}`,
    );
    set({ myEvals: response?.data?.data.evalresult });
    console.log(response?.data, "My Evals");
  },

  addFavouriteEval: async (evaluation_id) => {
    var userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
    const response = await axios.post(
      `/nujobs/users/${userData.nujuid}/evaluations/${evaluation_id}/favorite`,
    );
    set({
      myFavouriteEvals: response?.data?.data?.map(
        (evalItem) => evalItem.qhevid,
      ),
    });
    console.log(response?.data);
  },

  getFavouriteEvals: async () => {
    var userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
    const response = await axios.get(
      `/nujobs/users/${userData.nujuid}/evaluations/favorites`,
    );
    set({
      myFavouriteEvalsIDs: response?.data?.data.favorites?.map(
        (evalItem) => evalItem.evaluationid,
      ),
      myFavouriteEvals: response?.data?.data.evaluations,
    });
    console.log(
      response?.data?.data.favorites?.map((evalItem) => evalItem.evaluationid),
      "My Evals favourites",
    );
  },

  deleteFavouriteEval: async (evaluation_id) => {
    var userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
    const response = await axios.delete(
      `/nujobs/users/${userData.nujuid}/evaluations/${evaluation_id}/favorite`,
    );
    console.log(response?.data);
  },
}));

export default useNuJobsStore;
